import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pos_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((r) => r, (err) => {
  if (err?.response?.status === 402 && err.response.data?.detail === "LICENCIA_VENCIDA") {
    window.dispatchEvent(new Event("license-expired"));
  }
  return Promise.reject(err);
});

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Ocurrió un error";
}

export const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_comandero-pos/artifacts/frm1evie_WhatsApp%20Image%202026-10-01%20at%2011.37.25%20AM.jpeg";

export default api;
